import { useAuth } from '../lib/auth'
import styles from './Login.module.css'

export function Login() {
  const { login } = useAuth()

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Fiket Admin</h1>
        <p className={styles.subtitle}>관리자 로그인</p>
        <div className={styles.buttons}>
          <button className={styles.kakao} onClick={() => login('kakao')}>
            카카오로 로그인
          </button>
          <button className={styles.naver} onClick={() => login('naver')}>
            네이버로 로그인
          </button>
          <button className={styles.google} onClick={() => login('google')}>
            구글로 로그인
          </button>
        </div>
      </div>
    </div>
  )
}
